"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPLCTermTag = void 0;
var UPLCTermTag;
(function (UPLCTermTag) {
    UPLCTermTag[UPLCTermTag["Var"] = 0] = "Var";
    UPLCTermTag[UPLCTermTag["Delay"] = 1] = "Delay";
    UPLCTermTag[UPLCTermTag["Lambda"] = 2] = "Lambda";
    UPLCTermTag[UPLCTermTag["Application"] = 3] = "Application";
    UPLCTermTag[UPLCTermTag["Const"] = 4] = "Const";
    UPLCTermTag[UPLCTermTag["Force"] = 5] = "Force";
    UPLCTermTag[UPLCTermTag["Error"] = 6] = "Error";
    UPLCTermTag[UPLCTermTag["Builtin"] = 7] = "Builtin";
    UPLCTermTag[UPLCTermTag["Constr"] = 8] = "Constr";
    UPLCTermTag[UPLCTermTag["Case"] = 9] = "Case";
})(UPLCTermTag = exports.UPLCTermTag || (exports.UPLCTermTag = {}));
Object.freeze(UPLCTermTag);
